import styled from "styled-components";

import bg from '@/images/bg.jpg';

const View = styled.div`
  min-width: 1000px;
  min-height: 100vh;
  overflow-x: hidden;
  background-position: center top;
  background-size: 1920px auto;
  background-repeat: no-repeat;
  background-image: url("${bg}");
  font-family: 微软雅黑, -apple-system, Helvetica, sans-serif;

  & > div.content {
    position: relative;
    display: block;
    margin: 556px auto 0;
    width: 1000px;
    min-height: calc(2650px - 556px);
    user-select: none;
  }
`;


export {
  View
}
